import React from 'react';
import { IconProps } from '../Icon';
import * as Icon from '../Icons';

export type IconDynamicProps = {
  name: Uncapitalize<keyof typeof Icon>;
};

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const IconDynamic: React.FC<IconProps & IconDynamicProps> = ({
  name,
  ...props
}) => {
  const Component = Icon[capitalize(name)];

  if (!Component) {
    return null;
  }

  return <Component {...props} />;
};

export default IconDynamic;
